import { ProjectCalendarNavigationType, ProjectCalendarType } from './types';

export const DAY_TILE_WIDTH_SMALL = 32;
export const DAY_TILE_HEIGHT_SMALL = 32;
export const DAY_TILE_WIDTH_BIG = 40;
export const DAY_TILE_HEIGHT_BIG = 40;

export const calendarConfigs = {
  events: (
    value: Date | null,
    events: any,
    onValueChange: (value: Date | null) => void,
    activeStartDate: Date,
    onPreviousPress: () => void,
    onNextPress: () => void,
  ) => ({
    value,
    onValueChange,
    events,
    variant: 'dailyAlux' as ProjectCalendarType,
    navigationType: 'custom' as ProjectCalendarNavigationType,
    onPreviousPress,
    onNextPress,
    activeStartDate,
  }),
  modal: (values: Date[], onValuesChange: (value: Date[]) => void) => ({
    values,
    onValuesChange,
    variant: 'modal' as ProjectCalendarType,
    navigationType: 'default' as ProjectCalendarNavigationType,
    selectRange: true,
  }),
  picker: (
    value: Date | null,
    onValueChange: (value: Date | null) => void,
    minDate: Date | undefined,
    maxDate: Date | undefined,
  ) => ({
    value,
    onValueChange,
    minDate,
    maxDate,
    variant: 'picker' as ProjectCalendarType,
    navigationType: 'default' as ProjectCalendarNavigationType,
  }),
};
